import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "309",
  "slug": "spot-kazakhstan-from-satellite-imagery",
  "title": "How to Recognise Kazakhstan in Satellite Images",
  "excerpt": "Much of Kazakhstan is open lowland or steppe, with drier country towards the south and mountains in the east and southeast.",
  "date": "2026-03-26",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/kazakhstan.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Much of Kazakhstan is open lowland or steppe, with drier country towards the south and mountains in the east and southeast. The Caspian coast and Lake Balkhash are useful landmarks in a regional view. The country has a large interior, so a close crop may contain little that fixes a location."
    },
    {
      "type": "heading",
      "text": "Steppe, inland water, and southeastern mountains"
    },
    {
      "type": "paragraph",
      "text": "Locate Lake Balkhash and compare the open country to its north with the mountain terrain to the southeast."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Southern Russia shares steppe and large agricultural fields. Dry land also extends into Uzbekistan and other neighbours. Soviet-era infrastructure is not exclusive to Kazakhstan. A major lake or a mountain front is a stronger regional clue."
    }
  ],
  "imageAlt": "Kazakhstan regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
